import { securityRoleMembers } from "./SecurityRoleMembers.slice";

export const securityRoleMembersActions = { ...securityRoleMembers.actions };
